import { render, staticRenderFns } from "./multiContent.vue?vue&type=template&id=c134639c&scoped=true"
import script from "./multiContent.vue?vue&type=script&lang=ts"
export * from "./multiContent.vue?vue&type=script&lang=ts"
import style0 from "./multiContent.vue?vue&type=style&index=0&id=c134639c&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c134639c",
  null
  
)

export default component.exports